import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE = "https://marketluz.com/laravel8/public/api";

const DetalleProducto = () => {
  const { id } = useParams();

  // ==========================================
  // ESTADOS DEL PRODUCTO
  // ==========================================

  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagenPrincipal, setImagenPrincipal] = useState("");

  // ==========================================
  // ESTADOS DE COMENTARIOS Y ESTRELLAS
  // ==========================================

  const [nombre, setNombre] = useState("");
  const [nuevoComentario, setNuevoComentario] = useState("");
  const [estrellas, setEstrellas] = useState(0);
  const [comentarios, setComentarios] = useState([]);

  const [cargandoComentarios, setCargandoComentarios] = useState(true);
  const [enviandoComentario, setEnviandoComentario] = useState(false);

  const [mensaje, setMensaje] = useState("");
  const [errorComentario, setErrorComentario] = useState("");

  // ==========================================
  // NUEVO: MOSTRAR / OCULTAR FORMULARIO
  // ==========================================

  const [mostrarFormulario, setMostrarFormulario] = useState(false);

  // ==========================================
  // CARGAR DETALLES DEL PRODUCTO
  // ==========================================

  useEffect(() => {
    let activo = true;

    setLoading(true);
    setImagenPrincipal("");

    fetch(`${API_BASE}/productoDetalle/${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Error al cargar el producto");
        }
        return res.json();
      })
      .then((data) => {
        if (!activo) return;

        const lista = data.data || [];
        setDetalles(lista);

        if (lista.length > 0) {
          setImagenPrincipal(lista[0].image_url);
        }
      })
      .catch((error) => {
        console.error(error);
        if (activo) setDetalles([]);
      })
      .finally(() => {
        if (activo) setLoading(false);
      });

    return () => {
      activo = false;
    };
  }, [id]);

  // ==========================================
  // CARGAR COMENTARIOS DEL PRODUCTO
  // ==========================================

  const cargarComentarios = async () => {
    try {
      setCargandoComentarios(true);
      setErrorComentario("");

      const respuesta = await fetch(
        `${API_BASE}/productos/${id}/comentarios`
      );

      if (!respuesta.ok) {
        throw new Error("No se pudieron cargar los comentarios");
      }

      const data = await respuesta.json();
      setComentarios(data.data || []);
    } catch (error) {
      console.error("Error cargando comentarios:", error);
      setErrorComentario("No se pudieron cargar los comentarios.");
    } finally {
      setCargandoComentarios(false);
    }
  };

  // ==========================================
  // CARGAR COMENTARIOS AL CAMBIAR PRODUCTO
  // ==========================================

  useEffect(() => {
    let activo = true;

    const cargar = async () => {
      setCargandoComentarios(true);
      setErrorComentario("");
      setComentarios([]);
      setNombre("");
      setNuevoComentario("");
      setEstrellas(0);
      setMensaje("");

      // OCULTAR FORMULARIO AL CAMBIAR PRODUCTO
      setMostrarFormulario(false);

      try {
        const respuesta = await fetch(
          `${API_BASE}/productos/${id}/comentarios`
        );

        if (!respuesta.ok) {
          throw new Error("No se pudieron cargar los comentarios");
        }

        const data = await respuesta.json();

        if (activo) {
          setComentarios(data.data || []);
        }
      } catch (error) {
        console.error(error);

        if (activo) {
          setErrorComentario(
            "No se pudieron cargar los comentarios."
          );
        }
      } finally {
        if (activo) setCargandoComentarios(false);
      }
    };

    cargar();

    return () => {
      activo = false;
    };
  }, [id]);

  // ==========================================
  // PUBLICAR COMENTARIO CON ESTRELLAS
  // ==========================================

  const publicarComentario = async (e) => {
    e.preventDefault();

    if (enviandoComentario) return;

    setMensaje("");
    setErrorComentario("");

    const nombreLimpio = nombre.trim();
    const comentarioLimpio = nuevoComentario.trim();

    // VALIDAR NOMBRE Y COMENTARIO

    if (!nombreLimpio || !comentarioLimpio) {
      setErrorComentario(
        "Por favor completa tu nombre y comentario."
      );
      return;
    }

    // VALIDAR ESTRELLAS

    if (estrellas < 1 || estrellas > 5) {
      setErrorComentario(
        "Por favor selecciona de 1 a 5 estrellas."
      );
      return;
    }

    try {
      setEnviandoComentario(true);

      const respuesta = await fetch(
        `${API_BASE}/productos/comentarios`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            producto_id: Number(id),
            nombre: nombreLimpio,
            comentario: comentarioLimpio,
            estrellas: estrellas,
          }),
        }
      );

      const data = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          data.message || "No se pudo publicar el comentario"
        );
      }

      // RECARGAR COMENTARIOS DESDE MYSQL

      await cargarComentarios();

      // LIMPIAR FORMULARIO

      setNombre("");
      setNuevoComentario("");
      setEstrellas(0);

      // OCULTAR FORMULARIO DESPUES DE PUBLICAR

      setMostrarFormulario(false);

      setMensaje("Comentario y calificación publicados correctamente.");

    } catch (error) {
      console.error("Error publicando comentario:", error);

      setErrorComentario(
        error.message || "No se pudo publicar el comentario."
      );
    } finally {
      setEnviandoComentario(false);
    }
  };

  // ==========================================
  // FORMATEAR FECHA
  // ==========================================

  const formatearFecha = (fecha) => {
    if (!fecha) return "";

    const fechaFormateada = new Date(
      fecha.replace(" ", "T")
    );

    if (Number.isNaN(fechaFormateada.getTime())) {
      return fecha;
    }

    return fechaFormateada.toLocaleString("es-PE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ==========================================
  // COMPONENTE VISUAL DE ESTRELLAS
  // ==========================================

  const mostrarEstrellas = (cantidad) => {
    return (
      <div
        className="d-flex align-items-center gap-1"
        aria-label={`${cantidad} de 5 estrellas`}
      >
        {[1, 2, 3, 4, 5].map((estrella) => (
          <span
            key={estrella}
            style={{
              fontSize: "23px",
              color:
                estrella <= Number(cantidad)
                  ? "#ffc107"
                  : "#adb5bd",
              lineHeight: 1,
            }}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  // ==========================================
  // CARGANDO PRODUCTO
  // ==========================================

  if (loading) {
    return (
      <div className="text-center mt-5 fs-5">
        Cargando...
      </div>
    );
  }

  // ==========================================
  // SIN DETALLES
  // ==========================================

  if (detalles.length === 0) {
    return (
      <div className="text-center mt-5 fs-5">
        No hay detalles disponibles.
      </div>
    );
  }

  return (
    <div className="container mt-4 mb-5">

      {/* ==========================================
          TITULO
      ========================================== */}

      <h3 className="text-center mb-4 fw-bold">
        Detalles del Producto
      </h3>

      {/* ==========================================
          INFORMACION DEL PRODUCTO
      ========================================== */}

      <div className="row justify-content-center align-items-start">

        {/* MINIATURAS */}

        <div className="col-md-2 d-flex flex-column align-items-center gap-3">

          {detalles.map((detalle) => (
            <img
              key={detalle.id}
              src={detalle.image_url}
              alt={detalle.image_description}
              onClick={() =>
                setImagenPrincipal(detalle.image_url)
              }
              className={`img-thumbnail shadow-sm ${
                imagenPrincipal === detalle.image_url
                  ? "border-primary"
                  : ""
              }`}
              style={{
                width: "100%",
                height: "80px",
                objectFit: "cover",
                cursor: "pointer",
                borderRadius: "10px",
                transition: "0.3s",
              }}
            />
          ))}

        </div>

        {/* IMAGEN PRINCIPAL */}

        <div className="col-md-6 text-center">

          <div className="card shadow-sm border-0 rounded-4">

            <img
              src={imagenPrincipal}
              alt="Producto principal"
              className="img-fluid rounded-4"
              style={{
                maxHeight: "450px",
                objectFit: "contain",
                backgroundColor: "#f8f9fa",
                padding: "15px",
              }}
            />

          </div>

        </div>

        {/* ESPECIFICACIONES */}

        <div className="col-md-4">

          <div className="card shadow-sm border-0 rounded-4">

            <div className="card-body p-4">

              <h5 className="fw-bold mb-4 text-primary text-center">
                Especificaciones del producto
              </h5>

              <div className="list-group list-group-flush">

                {detalles.map((detalle, index) => (

                  <div
                    key={detalle.id}
                    className="list-group-item px-0 py-3 border-0 border-bottom"
                  >

                    <span className="fw-semibold text-dark">
                      {index + 1}.{" "}
                      {detalle.image_description}
                    </span>

                  </div>

                ))}

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* ==========================================
          COMENTARIOS DEL PRODUCTO
      ========================================== */}

      <div className="row justify-content-center mt-5">

        <div className="col-12 col-md-10 col-lg-8">

          <div className="card shadow-sm border-0 rounded-4">

            <div className="card-body p-4 p-md-5">

              <h4 className="fw-bold text-center mb-4">
                Comentarios del producto
              </h4>

              {/* ==========================================
                  NUEVO: PREGUNTA DESPLEGABLE
              ========================================== */}

              <div className="mb-4">

                <button
                  type="button"
                  onClick={() =>
                    setMostrarFormulario(!mostrarFormulario)
                  }
                  aria-expanded={mostrarFormulario}
                  aria-controls="formulario-opinion"
                  className="w-100 d-flex justify-content-between align-items-center"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    borderRadius: "10px",
                    padding: "15px 20px",
                    cursor: "pointer",
                    fontSize: "17px",
                    fontWeight: "600",
                    color: "#333",
                    transition: "background-color 0.3s ease",
                    textAlign: "left",
                  }}
                >

                  ¿Qué opinas de este producto?

                  <span
                    style={{
                      color: "#0d6efd",
                      fontSize: "18px",
                    }}
                  >
                    {mostrarFormulario ? "▲" : "▼"}
                  </span>

                </button>

              </div>

              {/* MENSAJES */}

              {mensaje && (
                <div
                  className="alert alert-success text-center"
                  role="alert"
                >
                  {mensaje}
                </div>
              )}

              {errorComentario && (
                <div
                  className="alert alert-danger text-center"
                  role="alert"
                >
                  {errorComentario}
                </div>
              )}

              {/* ==========================================
                  NUEVO: DIV PARA OCULTAR / MOSTRAR
              ========================================== */}

              <div
                id="formulario-opinion"
                style={{
                  display: mostrarFormulario ? "block" : "none",
                }}
              >

                {/* ==========================================
                    FORMULARIO
                ========================================== */}

                <form onSubmit={publicarComentario}>

                  {/* NOMBRE */}

                  <div className="mb-3">

                    <label className="form-label fw-semibold">
                      Nombre
                    </label>

                    <input
                      type="text"
                      className="form-control rounded-3"
                      placeholder="Ej. Juan Pérez"
                      value={nombre}
                      onChange={(e) =>
                        setNombre(e.target.value)
                      }
                      maxLength={60}
                      disabled={enviandoComentario}
                      style={{
                        padding: "12px 15px",
                      }}
                    />

                  </div>

                  {/* COMENTARIO */}

                  <div className="mb-3">

                    <label className="form-label fw-semibold">
                      Comentario
                    </label>

                    <textarea
                      className="form-control rounded-3"
                      rows="4"
                      placeholder="Escribe tu opinión sobre este producto..."
                      value={nuevoComentario}
                      onChange={(e) =>
                        setNuevoComentario(e.target.value)
                      }
                      maxLength={300}
                      disabled={enviandoComentario}
                      style={{
                        resize: "none",
                        padding: "12px 15px",
                      }}
                    />

                    <div className="text-end mt-1">

                      <small className="text-muted">
                        {nuevoComentario.length}/300
                      </small>

                    </div>

                  </div>

                  {/* ==========================================
                      SELECCIONAR ESTRELLAS
                  ========================================== */}

                  <div className="mb-4 text-center">

                    <label className="form-label fw-semibold d-block mb-3">
                      ¿Qué calificación le das a este producto?
                    </label>

                    <div className="d-flex justify-content-center gap-2">

                      {[1, 2, 3, 4, 5].map((estrella) => (

                        <button
                          key={estrella}
                          type="button"
                          onClick={() => setEstrellas(estrella)}
                          disabled={enviandoComentario}
                          aria-label={`Calificar con ${estrella} estrellas`}
                          aria-pressed={estrellas === estrella}
                          style={{
                            background: "transparent",
                            border: "none",
                            padding: "3px",
                            cursor: enviandoComentario
                              ? "not-allowed"
                              : "pointer",
                            fontSize: "38px",
                            lineHeight: 1,
                            color:
                              estrella <= estrellas
                                ? "#ffc107"
                                : "#adb5bd",
                            transition: "color 0.2s ease",
                          }}
                        >
                          ★
                        </button>

                      ))}

                    </div>

                    <small className="text-muted d-block mt-2">

                      {estrellas === 0
                        ? "Selecciona de 1 a 5 estrellas"
                        : `${estrellas} de 5 estrellas seleccionadas`}

                    </small>

                  </div>

                  {/* BOTON PUBLICAR */}

                  <div className="text-center">

                    <button
                      type="submit"
                      className="btn btn-primary px-5 py-2 fw-semibold rounded-3"
                      disabled={enviandoComentario}
                    >
                      {enviandoComentario
                        ? "Publicando..."
                        : "Publicar comentario"}
                    </button>

                  </div>

                </form>

              </div>

              {/* FIN DEL FORMULARIO DESPLEGABLE */}

            </div>

          </div>

          {/* ==========================================
              LISTA DE COMENTARIOS
          ========================================== */}

          <div className="mt-4">

            <h5 className="fw-bold mb-3">
              Opiniones ({comentarios.length})
            </h5>

            {cargandoComentarios ? (

              <div className="card shadow-sm border-0 rounded-4">

                <div className="card-body text-center p-4">

                  <p className="text-muted mb-0">
                    Cargando comentarios...
                  </p>

                </div>

              </div>

            ) : comentarios.length === 0 ? (

              <div className="card shadow-sm border-0 rounded-4">

                <div className="card-body text-center p-4">

                  <p className="text-muted mb-0">
                    Todavía no hay comentarios para este producto.
                  </p>

                </div>

              </div>

            ) : (

              comentarios.map((comentario) => (

                <div
                  key={comentario.id}
                  className="card shadow-sm border-0 rounded-4 mb-3"
                >

                  <div className="card-body p-4">

                    {/* USUARIO */}

                    <div className="d-flex align-items-center mb-3">

                      {/* AVATAR */}

                      <div
                        className="d-flex align-items-center justify-content-center fw-bold text-white bg-primary"
                        style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "50%",
                          flexShrink: 0,
                        }}
                      >
                        {(comentario.nombre || "?")
                          .charAt(0)
                          .toUpperCase()}
                      </div>

                      {/* NOMBRE Y FECHA */}

                      <div className="ms-3">

                        <div className="fw-bold">
                          {comentario.nombre}
                        </div>

                        <small className="text-muted">
                          {formatearFecha(comentario.fecha)}
                        </small>

                      </div>

                    </div>

                    {/* ==========================================
                        ESTRELLAS DEL COMENTARIO
                    ========================================== */}

                    {comentario.estrellas != null && (

                      <div className="mb-3 d-flex align-items-center gap-2">

                        {mostrarEstrellas(comentario.estrellas)}

                        <small className="text-muted">
                          {comentario.estrellas}/5
                        </small>

                      </div>

                    )}

                    {/* COMENTARIO */}

                    <p
                      className="mb-0 text-dark"
                      style={{
                        lineHeight: "1.6",
                      }}
                    >
                      {comentario.comentario}
                    </p>

                  </div>

                </div>

              ))

            )}

          </div>

        </div>

      </div>

    </div>
  );
};

export default DetalleProducto;